<ng-template [ngIf]="disabled">
    <div class="input-group">
        <div class="input-group-prepend">
            <span class="input-group-text">
                {{nomeTipoClassificacao ? nomeTipoClassificacao : 'NENHUM TIPO'}}
            </span>
        </div>
        <input type="text" class="form-control" [value]="classificacao?.nome" disabled="disabled" readonly="readonly">
    </div>
</ng-template>

<ng-template [ngIf]="!disabled">
    <div class="classificacao-select">
        <small>
            {{nomeTipoClassificacao ? nomeTipoClassificacao : 'NENHUM TIPO'}}
        </small>
        <select 
            #select
            class="form-control" 
            [name]="name"
            [id]="id"
            [required]="required"
            [ngModel]="ngModel || ''" 
            (ngModelChange)="onChange($event ? $event : null)">
            <option value=""></option>
            <option *ngFor="let classificacao of classificacoes" [ngValue]="classificacao.id" [disabled]="isSituacaoInativa(classificacao.situacao)">{{classificacao.nome}}</option>
        </select>    
    </div>
</ng-template>
